import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { upsellMessageContentSelector, upsellMessageVisibilitySelector } from 'selectors/uiSelectors';
import MessageHolder from 'components/messages/MessageHolder';
import { closeUpsellMessage } from '../../actions/uiActions';
import { gtmTrack } from '../../actions/analyticsActions';
import { analyticsActions, analyticsEvents } from '../../constants/analytics';
// @ts-expect-error
import upgradeImg from 'images/upgrade.svg';

function UpsellMessage() {
    const dispatch = useDispatch();
    const isVisible = useSelector(state => upsellMessageVisibilitySelector(state));
    const upsellMessageContent = useSelector(state => upsellMessageContentSelector(state));

    if (isVisible) {
        return (
            // @ts-expect-error
            <MessageHolder
                onClose={() => {
                    dispatch(closeUpsellMessage());
                    dispatch(
                        gtmTrack({
                            action: analyticsActions.CLOSE,
                            event: analyticsEvents.UPSELL_MESSAGE,
                        }),
                    );
                }}
            >
                <>
                    <div className="mg-modal-header is-mngls uk-padding-remove">
                        <img src={upgradeImg} alt="Upgrade my plan" width="110" />
                    </div>
                    <div className="uk-flex uk-flex-wrap">
                        <div className="uk-width-large-1-1   uk-flex uk-flex-middle uk-flex-center">
                            <div className="mg-modal-content">
                                <h3 className="font-30 uk-text-bold mg-margin-t-30">{upsellMessageContent.title}</h3>
                                <p className="font-16">{upsellMessageContent.description}</p>
                                <div className="mg-margin-t-30">
                                    <a
                                        className="mg-btn is-green is-gradient"
                                        href={upsellMessageContent.buttonLink}
                                    >
                                        <strong>{upsellMessageContent.buttonText}</strong>
                                    </a>
                                    <div className="font-14 color-grey mg-margin-t-10">
                                        {upsellMessageContent.buttonDescription}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </MessageHolder>
        );
    } else {
        return null;
    }
}

export default UpsellMessage;
